import React, { ReactElement, useContext, useEffect, useState } from 'react'
import axios from 'axios'
import { ArtData } from '@/database/art'
import { Context } from '@/components/Context'
import serverConfig from '@/server-config'
import ListingOverview from '@/components/market/ListingOverview'
import DetailsOverview from '@/components/market/DetailsOverview'
import MyDetailsOverview from '@/components/market/MyDetailsOverview'
import { ArtState } from '@/database/types'
import { UpdateType } from '@/types/websocket'

axios.defaults.baseURL = serverConfig.baseURL
const tabName = '#market'

const MarketOverview = (): ReactElement => {
    const { artDataList, currentAccount, setActiveUpdates } = useContext(Context)
    const [isModalDetailsOpen, setIsModalDetailsOpen] = useState(false)
    const [isModalMyDetailsOpen, setIsModalMyDetailsOpen] = useState(false)
    const [modalArtData, setModalArtData] = useState<ArtData>({} as ArtData)

    const openModalMarketCardDetails = (artData: ArtData) => {
        if (artData) {
            setModalArtData(artData)
            setIsModalMyDetailsOpen(false)
            setIsModalDetailsOpen(true)
        }
    }

    const openModalMyMarketCardDetails = (artData: ArtData) => {
        if (artData) {
            setModalArtData(artData)
            setIsModalDetailsOpen(false)
            setIsModalMyDetailsOpen(true)
        }
    }

    const closeModal = () => {
        window.location.hash = tabName
        setIsModalDetailsOpen(false)
        setIsModalMyDetailsOpen(false)
    }

    useEffect(() => {
        setActiveUpdates([UpdateType.MARKETS])
    }, [])

    useEffect(() => {
        const checkHashAndOpenModal = () => {
            const hash = window.location.hash
            const match = RegExp(/#nft-(\d+)/).exec(hash)
            if (match) {
                const selectedArt: ArtData | undefined = artDataList.find(
                    (artData) => artData.tokenId === Number(match[1]),
                )
                if (
                    selectedArt &&
                    selectedArt.state !== ArtState.FORCED_AUCTION &&
                    selectedArt.state !== ArtState.AUCTION
                ) {
                    if (selectedArt.art.currentOwner === currentAccount) {
                        openModalMyMarketCardDetails(selectedArt)
                    } else {
                        openModalMarketCardDetails(selectedArt)
                    }
                }
            }
        }

        // Check hash on mount
        checkHashAndOpenModal()

        // Add event listener for hash changes
        window.addEventListener('hashchange', checkHashAndOpenModal, false)

        // Cleanup event listener on component unmount
        return () => window.removeEventListener('hashchange', checkHashAndOpenModal, false)
    }, [artDataList, currentAccount])

    return (
        <div>
            {!isModalDetailsOpen && !isModalMyDetailsOpen && (
                <ListingOverview
                    openModalMarketCardDetails={openModalMarketCardDetails}
                    openModalMyMarketCardDetails={openModalMyMarketCardDetails}
                />
            )}
            {isModalDetailsOpen && modalArtData && <DetailsOverview artData={modalArtData} onClose={closeModal} />}
            {isModalMyDetailsOpen && modalArtData && <MyDetailsOverview artData={modalArtData} onClose={closeModal} />}
        </div>
    )
}
MarketOverview.whyDidYouRender = true

export default MarketOverview
